<template>
  <div class="z-card">
    <div class="z-card__title">
      <h2>{{ $t('core.document.form.title') }}</h2>
    </div>
    <div class="z-card__body">
      <div class=" mt-3">
        <template v-if="upload_list.length > 0 && !loading">
          <upload-table :upload_list="upload_list" @remove_file="remove_file" />
        </template>
      </div>

      <div class=" mt-3">
        <p v-html="$t('core.document.form.text')"></p>
      </div>

      <div class="mt-4">
        <div class="d-flex">
          <template v-if="!is_limited_files">
            <upload-btn :is_loading="loading" class="mt-0" @before_upload="before_upload" />
          </template>
          <template v-if="upload_list.length > 0">
            <i-button
              icon="ios-cloud-upload-outline"
              size="large"
              type="success"
              :loading="loading"
              class="ml-3"
              @click="save"
            >
              {{ $t('core.document.form.save_file_btn') }}
            </i-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UploadTable from './documents-upload-table';
  import UploadBtn from './documents-upload-btn';
  import { DocumentService } from '@core/services/DocumentService';
  export default {
    components: { UploadTable, UploadBtn },
    data: () => ({
      loading: false,
      upload_list: [],
      limit_files: 5,
      count_files: 0
    }),
    computed: {
      is_limited_files() {
        return this.upload_list.length === this.limit_files;
      }
    },
    methods: {
      set_thumb_file(file) {
        let reader = new FileReader();
        reader.onload = e => {
          const blob = e.target.result;
          file.is_preview = true;
          file.blob = blob;
          this.upload_list.push(file);
        };
        reader.onerror = e => console.error(e);
        reader.readAsDataURL(file);
      },
      remove_file(file) {
        this.count_files = this.count_files - 1;
        this.upload_list.splice(this.upload_list.indexOf(file), 1);
      },
      before_upload: function(file) {
        if (this.count_files < this.limit_files) {
          this.count_files = this.count_files + 1;
          if (file.type === 'application/pdf') {
            file.is_preview = false;
            this.upload_list.push(file);
          } else {
            this.set_thumb_file(file);
          }
        }
      },
      save() {
        const files = [...this.upload_list];
        this.loading = true;
        const create_document_request = files.map(file => {
          const formData = new FormData();
          formData.append('file', file);
          return DocumentService.createItem(formData)
            .then(() => {
              this.upload_list.splice(this.upload_list.indexOf(file), 1);
            })
            .catch(e => this.$noty.server_error(e));
        });
        Promise.all(create_document_request)
          .then(() => {
            this.$router.push({ name: 'core.document.index' });
          })
          .catch(e => this.$noty.server_error(e))
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
